/* Books shelf — BEHAVIOUR ONLY. Generated from book-shelf-v5.html by
   scripts/books-build/10-build-section.mts. Every title, price and image URL
   is read at runtime from the section's #osb-shelf island (Liquid reading
   Shopify, product fields and `books.*` metafields alike), and the reader
   half from `?view=booksreader` once the page has painted. Edit the
   generator and shelf-runtime.js, not this file. */
/* ---------------------------------------------------------------------------
   Books shelf — RUNTIME. Behaviour only; there is no book data in this file.
   ---------------------------------------------------------------------------

   THE PAGE CARRIES ONLY WHAT DRAWS A CLOSED SHELF. Two payloads, both rendered
   by Liquid from Shopify at request time, neither of them baked:

     #osb-shelf   — in the page. One entry per product in the books collection:
                    title, price, compare-at, handle, url, tags, type, vendor,
                    availability, variant id, the COVER and the HOVER page (with
                    their dimensions), and the `books.*` metafields the shelf
                    draws with — book_key, author, shelf_caption, jbg, spines,
                    height_mm, shelf_height_mm, shelf_position, edition_group.
     #osb-reader  — NOT in the page. `templates/collection.booksreader.liquid`,
                    fetched as `location.pathname + '?view=booksreader'` once the
                    shelf has painted: every interior page's URL, the reader's
                    cover stand-in, our copy, the publisher's blurb, the binding
                    detail, and the paired-toy cards. Roughly 88KB of markup and
                    URLs that a visitor who never opens a book never pays for.

   BOTH HALVES COME FROM SHOPIFY. The editorial half used to be a second island
   baked into the section by the generator, which meant every jacket colour and
   caption needed a rebuild and a theme upload. It is `books.*` metafields now,
   published from the `books` table by pairingPublishService — one writer, one
   direction, and the page follows the database on the next load.

   THE DEFERRAL MUST NOT MAKE A FLIP WAIT. The reader pre-warms every page of a
   book as it opens, because without it a flip visibly stalled on the network.
   That is untouched: the payload is asked for three ways — on idle after the
   shelf has painted, on the first pointer or focus that lands anywhere on the
   shelf, and (as the backstop) on the open itself, which waits for it. By the
   time a book opens the URLs are in hand and the pre-warm runs exactly as it
   did. A failed fetch is not fatal: the book still opens on its cover, its
   about page and its why page.

   MEASUREMENT. The generator used to open every file with `sharp` at build time
   to work out a cover's aspect ratio, whether the hover page should bleed, and
   whether a title reads one page per opening. Shopify's image objects carry
   `width` and `height`, so all three are derived here from the payload instead
   — same three rules, same thresholds, no build step and nothing to go stale.
   The first two need only the cover and the hover and so are decided on the
   shelf; `one_up` needs every interior and is decided when the reader payload
   arrives, which is before any book can open.

   This file is loaded by the generator and prepended to the asset verbatim, and
   the tests in `shelf-runtime.test.ts` evaluate these exact bytes. It is a
   classic script, not a module: no `import`, no `export`, and every name it
   defines is deliberately global because the mock's code shares that scope.
--------------------------------------------------------------------------- */

/* Shopify's CDN resizes on the fly via ?width= — without it every reader page
   is a multi-MB original and the right-hand page visibly stalls on open and
   flip. Pages render ~500px wide (x2 retina → 1000); covers at most ~400 (→800).
   Liquid emits a `width=` already, so this REPLACES rather than appends: two
   width params on one URL is not the smaller of the two, it is undefined. */
function osbSized(url, w) {
  if (!url) return url;
  if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}

var OSB_COVER_W = 800;
var OSB_PAGE_W = 1000;

/* The hover page bleeds to the jacket edge when its shape is close to the
   cover's — the same 12% tolerance fitPage applies inside the reader. */
var OSB_BLEED_LO = 0.89;
var OSB_BLEED_HI = 1.12;
/* Interiors whose MEDIAN aspect is landscape are whole spreads (or standalone
   photographs), not single pages: the reader shows one per opening even when
   the cover is portrait (The Lost Words — portrait cover, spread photos). */
var OSB_ONE_UP_AR = 1.05;

/* A jacket needs a colour even for a product the database has never seen, or
   the shelf draws a book-shaped hole. */
var OSB_DEFAULT_JBG = '#e6eadd';
var OSB_DEFAULT_H = '250';

function osbAspect(img) {
  return img && img.w > 0 && img.h > 0 ? img.w / img.h : 0;
}

function osbMedian(nums) {
  var sorted = nums.slice().sort(function (a, b) { return a - b; });
  return sorted[Math.floor(sorted.length / 2)];
}

/* The two flags the SHELF needs, from the cover and the hover page alone.
   `ar` is the jacket's shape; `hover_bleed` says the hover page is close enough
   to the cover's shape to run to the jacket's edge rather than sit inside it —
   the same 12% tolerance `fitPage` applies inside the reader. */
function osbMeasure(cov, hov) {
  var out = { ar: null, hover_bleed: false };
  if (cov && cov.w && cov.h) out.ar = cov.w + '/' + cov.h;
  var covAr = osbAspect(cov);
  var hovAr = osbAspect(hov);
  if (covAr > 0 && hovAr > 0) {
    var off = hovAr / covAr;
    out.hover_bleed = off >= OSB_BLEED_LO && off <= OSB_BLEED_HI;
  }
  return out;
}

/* One page per opening, even on a wide screen and a portrait cover: a title
   whose interiors are whole spreads (or standalone photographs) reads one at a
   time. Needs every interior, so it is decided when the reader payload lands. */
function osbOneUp(interiors) {
  var ars = [];
  for (var i = 0; i < (interiors || []).length; i++) {
    var a = osbAspect(interiors[i]);
    if (a > 0) ars.push(a);
  }
  if (!ars.length) return false;
  return osbMedian(ars) >= OSB_ONE_UP_AR;
}

/* One book, from its `#osb-shelf` entry. Everything a CLOSED shelf draws, and
   nothing else — `interior`, `d`, `blurb` and `detail` are filled in by
   osbApplyReader when the reader payload arrives.

   A product in the collection that the database has never seen still draws, in
   neutral, at the end: no `book_key` means it is keyed by handle, no `jbg`
   means the default jacket. A book-shaped hole would be worse than a plain one. */
function osbBook(p) {
  var measured = osbMeasure(p.cov, p.hov);
  var b = {
    tags: p.tags || [],
    t: p.title,
    a: p.author || p.vendor || '',
    pub: p.vendor || '',
    type: p.type || '',
    price: p.price,
    rrp: p.compare_at || '',
    d: '',
    h: String(p.shelf_height_mm || p.height_mm || OSB_DEFAULT_H),
    jbg: p.jbg || OSB_DEFAULT_JBG,
    cov: p.cov ? osbSized(p.cov.src, OSB_COVER_W) : null,
    interior: [],
    shelf_caption: p.shelf_caption || '',
    spines: p.spines || [],
    handle: p.handle,
    url: p.url,
    product_id: p.id,
    variant_id: p.variant_id,
    available: p.available !== false,
    ar: measured.ar,
    hover: p.hov ? osbSized(p.hov.src, OSB_PAGE_W) : null,
    hover_bleed: measured.hover_bleed
  };
  if (p.edition_group) b.edition_group = p.edition_group;
  /* The paired toy. Liquid emits `pairing` ONLY when the product reference
     resolves, which it does only for a toy published to the Online Store — so
     a pairing at a draft toy arrives as nothing at all, the card is absent, and
     it starts showing on the day the toy goes live with nothing re-run. */
  if (p.pairing) {
    b.pairing_name = p.pairing.name;
    b.pairing_url = p.pairing.url;
    b.pairing_reason = p.pairing.reason;
    b.pairing_variant_id = p.pairing.variant_id;
    b.pairing_available = p.pairing.available !== false;
  }
  return b;
}

/* The whole object, in shelf order. Order is editorial and comes from the
   database by way of `books.shelf_position`: the Shopify collection is a smart
   collection sorted BEST_SELLING, which on a catalogue with no sales yet is
   newest-first — the exact reverse of the shelf. Anything with no position
   sorts to the end, in collection order.

   Keyed by `book_key` — the pipeline key, published as a metafield — and never
   by handle: a handle renamed in admin would otherwise silently re-key every
   book on the shelf. A product with no key falls back to its handle. */
function osbBuildBooks(shelf) {
  var products = (shelf && shelf.products) || [];
  var rows = products.map(function (p, idx) {
    return { p: p, pos: p.shelf_position != null ? p.shelf_position : Infinity, idx: idx };
  });
  rows.sort(function (a, b) { return a.pos - b.pos || a.idx - b.idx; });

  var books = {};
  for (var j = 0; j < rows.length; j++) {
    books[rows[j].p.book_key || rows[j].p.handle] = osbBook(rows[j].p);
  }
  return books;
}

function osbJson(id) {
  var el = document.getElementById(id);
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
}

function osbReadBooks() {
  return osbBuildBooks(osbJson('osb-shelf') || { products: [] });
}

/* ---------------------------------------------------------------------------
   The reader payload
   ---------------------------------------------------------------------------
   `templates/collection.booksreader.liquid` rendered with `{% layout none %}`,
   asked for as the CURRENT path plus `?view=booksreader` — so the shelf on any
   collection gets that collection's reader payload, and nothing is pinned to
   /collections/books.

   It is fetched rather than inlined because it is roughly 88KB of page-image
   URLs, book copy and nine rendered product cards, none of which a visitor who
   only looks at the shelf ever needs. It is fetched EARLY — on idle, and on the
   first pointer or focus that lands on the shelf — because a book that opened
   into an empty reader would be a worse page than a heavy one.
--------------------------------------------------------------------------- */

var OSB_READER_VIEW = '?view=booksreader';
var OSB_READER_LOADED = false;
var OSB_READER_PENDING = null;
/* Paired-toy card markup by product id, out of the fetched document. The DOM
   fallback below is for the case where the payload was inlined into the page
   instead (the smoke test does exactly that, so the cards are testable). */
var OSB_PAIR_HTML = {};

/* Merge the reader payload into an already-built BOOKS. `books` is passed in
   rather than closed over so the CDN warmer and the smoke test can run this in
   Node, where there is no `BOOKS` and no DOM. */
function osbApplyReader(payload, books) {
  var list = (payload && payload.books) || [];
  var byId = {};
  for (var i = 0; i < list.length; i++) byId[String(list[i].id)] = list[i];
  for (var key in books) {
    if (!Object.prototype.hasOwnProperty.call(books, key)) continue;
    var b = books[key];
    var r = byId[String(b.product_id)];
    if (!r) continue;
    var interiors = r.interior || [];
    b.interior = interiors.map(function (im) { return osbSized(im.src, OSB_PAGE_W); });
    if (r.cov_page) b.covPage = osbSized(r.cov_page.src, OSB_COVER_W);
    if (r.description) b.d = r.description;
    if (r.blurb) b.blurb = r.blurb;
    if (r.detail) b.detail = r.detail;
    if (osbOneUp(interiors)) b.one_up = true;
  }
  return books;
}

/* Pure: the reader payload's URL for whatever page we are on. */
function osbReaderUrl(pathname) {
  return pathname + OSB_READER_VIEW;
}

/* Pull the JSON island and the card templates out of the fetched document.
   DOMParser makes an INERT document — nothing inside it is fetched, so parsing
   nine product cards does not pull nine photographs. */
function osbIngestReader(html, books) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var el = doc.getElementById('osb-reader');
  if (el) {
    try { osbApplyReader(JSON.parse(el.textContent), books); } catch (e) { /* leave the books as they are */ }
  }
  var tpls = doc.querySelectorAll('.osb-pair[data-product]');
  for (var i = 0; i < tpls.length; i++) {
    OSB_PAIR_HTML[tpls[i].getAttribute('data-product')] = tpls[i].innerHTML;
  }
}

function osbFetchReader() {
  if (OSB_READER_PENDING) return OSB_READER_PENDING;
  var done = function () { OSB_READER_LOADED = true; };
  var p;
  try {
    p = fetch(osbReaderUrl(location.pathname), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('reader payload ' + res.status);
        return res.text();
      })
      .then(function (html) { osbIngestReader(html, BOOKS); })
      /* A book still opens on its cover, its about page and its why page. One
         failed fetch must not be the difference between a reader and nothing. */
      .catch(function () {})
      .then(done);
  } catch (e) {
    p = Promise.resolve().then(done);
  }
  OSB_READER_PENDING = p;
  return p;
}

/* Run `cb` once the reader half is in hand — SYNCHRONOUSLY if it already is, so
   nothing that opens a book has to become async on the warm path. */
function osbReaderReady(cb) {
  if (OSB_READER_LOADED) { cb(); return; }
  var inline = osbJson('osb-reader');
  if (inline) {
    osbApplyReader(inline, BOOKS);
    OSB_READER_LOADED = true;
    cb();
    return;
  }
  osbFetchReader().then(cb, cb);
}

/* Every page of the book about to open, into the browser's cache, so a flip
   never waits on the network. This is why the payload is fetched early rather
   than on the click. */
function osbPrewarm(key) {
  var b = BOOKS[key];
  if (!b) return;
  (b.interior || []).forEach(function (u) { var im = new Image(); im.src = u; });
}

/* Three chances to have the payload before anyone opens a book: idle time once
   the shelf has painted, the first pointer or focus anywhere on the shelf, and
   the open itself. The listeners are `once` and passive — they only start a
   fetch, and the fetch de-duplicates itself. */
function osbScheduleReader() {
  if (typeof document === 'undefined') return;
  var kick = function () { osbFetchReader(); };
  var root = document.getElementById('osb');
  if (root) {
    ['pointerover', 'touchstart', 'focusin'].forEach(function (evt) {
      root.addEventListener(evt, kick, { once: true, passive: true });
    });
  }
  if (typeof requestIdleCallback === 'function') requestIdleCallback(kick, { timeout: 2000 });
  else setTimeout(kick, 1200);
}

/* ---------------------------------------------------------------------------
   Cart
   ---------------------------------------------------------------------------
   Ordinary Shopify cart adds, one line item or two, falling through to the
   theme's own drawer. The theme (Prestige) never listens for the fetch — its
   <cart-drawer> re-renders itself from the `cart:change` event's
   `detail.cart.sections[<its own section id>]`, and opens when
   `detail.baseEvent === 'variant:add'`. So the sequence a hand-rolled add has
   to reproduce is exactly the one `product-form` performs:

     1. ask the page which sections want re-rendering  (cart:prepare-bundled-sections)
     2. POST /cart/add.js with items[] AND those section ids
     3. GET /cart.js, and hang the add response's `sections` off it
     4. dispatch cart:change on documentElement with baseEvent 'variant:add'

   Skip step 1 or 3 and the drawer opens onto its old contents; skip step 4 and
   nothing opens at all and the header count goes stale.

   No line-item properties are sent, which adds the plain toy: engraving is a
   property rather than a variant, so asking here would turn one decision into
   three. The link under the buttons carries that instead.

   The 25%-off-the-book-with-a-toy discount is a Shopify automatic discount and
   applies in the cart on its own. Nothing here calculates a price.
--------------------------------------------------------------------------- */

function osbRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}

function osbAnnounce(msg) {
  var el = document.getElementById('live');
  if (el) el.textContent = msg;
}

/* Pure: which line items an add is, given the book and what was pressed.
   `both` puts the toy first so the cart drawer shows it above the book, the
   same order the page reads in. */
function osbCartItems(b, both) {
  var items = [];
  if (both && b.pairing_variant_id) items.push({ id: b.pairing_variant_id, quantity: 1 });
  if (b.variant_id) items.push({ id: b.variant_id, quantity: 1 });
  return items;
}

/* Pure: the sentence the live region gets. Announced only after the add has
   actually succeeded — the mock announced on click, which told a screen reader
   a thing was in the basket before anyone knew whether it was. */
function osbAddedMessage(b, both) {
  return both && b.pairing_name
    ? b.pairing_name + ' and ' + b.t + ' added to your basket.'
    : b.t + ' added to your basket.';
}

/* Pure: the /cart/add.js body. `sections_url` is what Shopify renders the
   requested sections against; the current path is right, and the theme's own
   form sends its variant URL only because that is where it happens to be. */
function osbCartBody(items, sections, path) {
  return { items: items, sections: sections.join(','), sections_url: path };
}

function osbBundledSections() {
  var sections = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
  );
  return sections;
}

/* The in-flight guard the theme's own product form has (Prestige's
   product-form ignores a submit while its button is aria-busy, i.e. while the
   request is out). PER BUTTON, as the theme's is: a tap on the button whose
   add is still on its way is ignored; a tap on a different add button goes
   through; a tap after the add has finished adds again, exactly as on a
   product page. The pressed button carries aria-busy for the duration. A
   caller with no button is guarded per add (the same item, the same "both").
   Cleared on success AND failure, in the final step below. */
var osbCartBusyKeys = {};

function osbCartBusyKey(b, both) {
  return String(b.variant_id) + (both ? '+' + String(b.pairing_variant_id) : '');
}

function osbCartAdd(b, both, btn) {
  var hasBtn = !!(btn && typeof btn.getAttribute === 'function');
  var busyKey = hasBtn ? null : osbCartBusyKey(b, both);
  if (hasBtn ? btn.getAttribute('aria-busy') === 'true' : osbCartBusyKeys[busyKey]) return Promise.resolve(false);
  var items = osbCartItems(b, both);
  if (!items.length) { osbAnnounce('That is not available at the moment.'); return Promise.resolve(false); }
  if (b.available === false && !both) { osbAnnounce(b.t + ' is out of stock.'); return Promise.resolve(false); }

  var root = osbRoot();
  var sections = osbBundledSections();
  if (hasBtn) btn.setAttribute('aria-busy', 'true'); else osbCartBusyKeys[busyKey] = true;
  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

  return fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(osbCartBody(items, sections, location.pathname)),
  })
    .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
    .then(function (r) {
      if (!r.ok) throw new Error((r.json && (r.json.description || r.json.message)) || 'Add to basket failed');
      return fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
        cart.sections = r.json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cart },
        }));
        osbAnnounce(osbAddedMessage(b, both));
        return true;
      });
    })
    .catch(function (err) {
      osbAnnounce(err && err.message ? err.message : 'Add to basket failed.');
      return false;
    })
    .then(function (done) {
      if (hasBtn) btn.removeAttribute('aria-busy'); else delete osbCartBusyKeys[busyKey];
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      return done;
    });
}

/* ---------------------------------------------------------------------------
   The paired-toy card
   ---------------------------------------------------------------------------
   Liquid renders the THEME'S OWN `product-card` snippet into a <template> per
   book, so the photograph, price and badges come from Shopify and stay in step
   with the rest of the store. It has to be a template rather than markup in the
   page because the reader builds its pages in JavaScript, and JavaScript cannot
   execute Liquid — which is why this slot used to render the literal string
   `{% render 'card-product' %}` in a dashed box.

   Nothing is inside the template until it is cloned, so no card image is
   fetched for a book nobody opens — and the templates themselves are no longer
   in the page at all: nine rendered cards is 43KB of markup for a card most
   visitors never see, so they ride in the READER PAYLOAD and are held here by
   product id. The DOM lookup is the fallback for a payload that was inlined
   into the page instead of fetched. */
function osbPairCard(productId) {
  var held = OSB_PAIR_HTML[String(productId)];
  if (held) return held;
  var tpl = document.querySelector('.osb-pair[data-product="' + productId + '"]');
  return tpl ? tpl.innerHTML : '';
}

/* Pure: an attribute value. Product URLs are `/products/<handle>` and safe as
   they stand, but this markup is assembled by string concatenation and a value
   that closes its own attribute is the one way that goes wrong. */
function osbAttr(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
    .replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/* Pure: "the " in front of a name — unless the name already opens with an
   article of its own.

   Two toys are titled "The Oak Box Set" and "The Canvas Bag Set", which made the
   card's link read "add it on the The Oak Box Set page". The operator ruled the
   article conditional rather than the products renamed (2026-08-30), so this has
   to keep holding for whatever a product is called next. Only a LEADING article
   counts: "A Tree" opens with one, "Alphabet Puzzle" does not, and neither does
   "Theo's Blocks" — the word boundary is what the \s is doing. */
function osbWithArticle(name) {
  var n = String(name == null ? '' : name).trim();
  if (!n) return n;
  return /^(the|a|an)\s/i.test(n) ? n : 'the ' + n;
}

/* The theme's card is a figure (the photograph) and an info block (title, price,
   review stars). The reader lays those SIDEWAYS — photograph left, name/stars/
   price right (operator ruling 2026-08-30) — so the two halves are separated
   here rather than styled into position, and each is placed in its own column.

   The clone happens in a DETACHED div: nothing is connected to the document, so
   `<product-card>` is never upgraded and none of the theme's card behaviour runs
   inside the reader. Falls back to the whole card in the figure slot if the
   theme's class names ever move — a card in one piece beats no card at all. */
var OSB_PAIR_PARTS = {};
function osbPairParts(productId) {
  if (OSB_PAIR_PARTS[productId]) return OSB_PAIR_PARTS[productId];
  var html = osbPairCard(productId);
  if (!html) return { figure: '', info: '' };
  var host = document.createElement('div');
  host.innerHTML = html;
  var figure = host.querySelector('.product-card__figure');
  var info = host.querySelector('.product-card__info');
  OSB_PAIR_PARTS[productId] = {
    figure: figure ? figure.outerHTML : html,
    info: info ? info.innerHTML : '',
  };
  return OSB_PAIR_PARTS[productId];
}

/* The left column: the photograph, and the whole of it is the click target.
   `data-href` is what the reader's tap handler navigates to — see the
   `paired-toy card navigates` patch in 10-build-section.mts. */
function osbPairMediaHTML(b) {
  var parts = osbPairParts(b.product_id);
  var href = b.pairing_url ? ' data-href="' + osbAttr(b.pairing_url) + '"' : '';
  return '<div class="pc-media' + (parts.figure ? ' has-card' : '') + '"' + href + '>' + parts.figure + '</div>';
}

/* The right column's Shopify half: review stars and price, in the theme's own
   markup so they look like they do everywhere else. The theme prints the raw
   product title in here too; the card already carries the operator's name for
   the toy right above it, so the title is hidden in CSS rather than stripped out
   — the theme owns this markup and a class name is the smaller thing to own. */
function osbPairInfoHTML(b) {
  var parts = osbPairParts(b.product_id);
  return parts.info ? '<div class="pc-info">' + parts.info + '</div>' : '';
}

/* ---------------------------------------------------------------------------
   Instrumentation
   ---------------------------------------------------------------------------
   The shelf is entirely client-side: opening a book, turning its pages, the
   format and age chips, the carousel and the deep link all happen without a
   navigation, so until this existed the whole page reported nothing but a
   `page_view`. Everything below rides the theme's own beacon.

   ⛔ EVERYTHING IS ENCODED INTO THE EVENT NAME as `family:label`. sGTM ingest
   tag #132 has a fixed body allowlist and silently drops any other `ep.*`
   param, so a second dimension is not available at any price.

   ⛔ NO BOOK HANDLE IN ANY NAME. GA4 caps a property at 500 distinct event
   names and this store is already over it (523 over 365 days, 438 over 60).
   Every label below comes from a FIXED set written in this file or in the
   section's markup, so the name count cannot grow with the catalogue — the
   same rule the reviews scroll ladder follows (.claude/REVIEWS.md §5A).

   THE BOOK IS IN THE URL INSTEAD, and that is why the ordering below is
   deliberate. `syncUrl` pushes `?book=<handle>` before the open is reported,
   so the beacon's `dl` — which lands in `stape_events.pageUrl` — carries the
   title. Fire before the URL sync and every open reads as the bare shelf.

     SELECT SUBSTRING_INDEX(SUBSTRING_INDEX(pageUrl, 'book=', -1), '&', 1)

   ⚠️ The rollup's `productHandle` will NOT pick that up: eventCanonicaliser's
   `extractProductHandle` looks for `/products/<handle>`, which a shelf URL
   never has. Per-book numbers are a raw `stape_events` query, not a rollup.
--------------------------------------------------------------------------- */

/* THE SENDER DOES NOT EXIST YET WHEN THIS FILE FIRST RUNS.
   `snippets/os-event-tracker.liquid` renders at the END of <body> and defines
   window.__OS_TRACK__ there. Click handlers are always later and are safe;
   anything fired on page LOAD is not, and the deep-link open below is exactly
   that. `review_form_view` was silently dropped for this and only surfaced in
   a live browser test with the code on the page and the selectors matching
   (.claude/REVIEWS.md §5A) — so queue, and flush when the tracker appears.

   Mirrors `osrTrack` in templates/page.leave-a-review.liquid: poll every 100ms
   and give up after 40 tries (~4s) rather than holding a timer forever on a
   page where the snippet never loads. One shared queue and one shared timer,
   because the shelf can queue more than one event before the flush. */
var OSB_TRACK_QUEUE = [];
var OSB_TRACK_TIMER = null;
var OSB_TRACK_TRIES = 0;
var OSB_TRACK_MAX_TRIES = 40;
var OSB_TRACK_POLL_MS = 100;

function osbTrackSender() {
  return typeof window !== 'undefined' && typeof window.__OS_TRACK__ === 'function'
    ? window.__OS_TRACK__
    : null;
}

function osbTrackFlush() {
  var send = osbTrackSender();
  if (!send) return false;
  var queued = OSB_TRACK_QUEUE;
  OSB_TRACK_QUEUE = [];
  for (var i = 0; i < queued.length; i++) {
    try { send(queued[i]); } catch (e) { /* one bad name must not lose the rest */ }
  }
  return true;
}

function osbTrack(name) {
  if (!name) return;
  OSB_TRACK_QUEUE.push(name);
  if (osbTrackFlush()) return;
  if (OSB_TRACK_TIMER || typeof setInterval !== 'function') return;
  OSB_TRACK_TRIES = 0;
  OSB_TRACK_TIMER = setInterval(function () {
    if (osbTrackFlush() || ++OSB_TRACK_TRIES > OSB_TRACK_MAX_TRIES) {
      clearInterval(OSB_TRACK_TIMER);
      OSB_TRACK_TIMER = null;
      /* Gave up: drop what is queued rather than hold it for a tracker that is
         never coming. A stale queue would fire on the NEXT page's tracker. */
      OSB_TRACK_QUEUE = [];
    }
  }, OSB_TRACK_POLL_MS);
}

/* Pure: the label for one filter chip. The chips' `data-filter` values are
   written into the section's markup by the generator — `all`, `fmt:board`,
   `series:national-trust`, `under-3` and so on — so the set is FIXED and a new
   chip is a code change, never a data change. The `fmt:`/`series:` prefixes are
   dropped: they are markup bookkeeping, they cost eventName characters, and
   `board` is not ambiguous with anything in the age group.

   Both groups' `all` deliberately collapse to one name. Clearing the format
   filter and clearing the age filter are the same act and asking GA4 for two
   names to tell them apart is not worth one of the ~0 it has left. */
function osbFilterLabel(raw) {
  var v = String(raw == null ? '' : raw).replace(/^(fmt|series):/, '');
  v = v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return v || 'all';
}

/* Pure: a FIXED ladder, not the turn count. One name per page index would grow
   with the longest book (and with every book added after it); these four rungs
   plus `end` describe the same curve and can never grow. Returns '' for a turn
   that is not a rung. */
var OSB_TURN_MILESTONES = [1, 3, 5, 10];

function osbTurnMilestone(turns) {
  for (var i = 0; i < OSB_TURN_MILESTONES.length; i++) {
    if (turns === OSB_TURN_MILESTONES[i]) return String(turns);
  }
  return '';
}

/* Per-opening state. Reset by osbTrackOpen so a second book starts its ladder
   again, and so a rung reached by turning forward, back and forward once more
   still reports once. */
var OSB_TURNS = 0;
var OSB_TURN_SEEN = {};

/* Called AFTER the URL carries ?book=<handle> — see the header. `source` is one
   of five fixed strings, and it is the whole point of the event: a shelf click,
   a carousel click, an edition swap inside the reader, a `?book=` landing (which
   is every book product page, since those redirect here) and a back/forward
   replay are five different acquisitions of the same reader. */
function osbTrackOpen(source) {
  OSB_TURNS = 0;
  OSB_TURN_SEEN = {};
  osbTrack('book_open:' + (source || 'shelf'));
}

/* One committed page turn. `index` is the leaf's new page index and `total` is
   the page count, both after the commit, so the last-page test is the same one
   `prep` uses to refuse a further forward turn. */
function osbCountTurn(index, total) {
  OSB_TURNS += 1;
  var rung = osbTurnMilestone(OSB_TURNS);
  if (rung && !OSB_TURN_SEEN[rung]) {
    OSB_TURN_SEEN[rung] = 1;
    osbTrack('book_turn:' + rung);
  }
  if (total > 0 && index + 1 >= total && !OSB_TURN_SEEN.end) {
    OSB_TURN_SEEN.end = 1;
    osbTrack('book_turn:end');
  }
}


/* The book data, from the section. Everything below is the mock, unchanged
   except where the generator patches it. */
const BOOKS = osbReadBooks();

const TYPE_KIND = {
  'Memory game'          : 'box',
  'Hardback'             : 'book',
  'Large-format hardback': 'book',
  'Board book'           : 'book',
  'Board book with sound': 'book',
  'Paperback'            : 'book',
  'Press-out model'      : 'book',
  'Sticker activity book': 'book'
};
const kindOf = b => TYPE_KIND[b.type] || 'book';

/* What people actually filter by. Format is a fact about the object and it is always
   right; age is a publisher's guess and often isn't. So format leads and age is behind
   a disclosure with a note saying why. */
const FORMAT_GROUP = {
  "Board book": "board",
  "Board book with sound": "board",
  "Hardback": "hardback",
  "Hardback with sound": "hardback",
  "Large-format hardback": "hardback",
  "Paperback": "paperback",
  "Memory game": "game",
  "Press-out model": "make",
  "Sticker activity book": "make"
};
const isBox  = b => kindOf(b) === 'box';

/* Tags carry the things a product can have several of — which shelf, which ages.
   Both are multi-value, both are native Shopify tags, and neither needs a metafield. */
const hasTag = (b, tag) => b.tags.indexOf(tag) !== -1;

const KEYS = Object.keys(BOOKS).filter(k => !BOOKS[k].hidden);   /* nothing hidden now — kept for future editions we don't want shelved */
let filterMain = "all", filterAge = "all";
function inFilter(k){
  const b = BOOKS[k];
  if(filterAge !== "all" && !hasTag(b, 'age:' + filterAge)) return false;
  if(filterMain === "all") return true;
  if(filterMain.startsWith('fmt:')) return FORMAT_GROUP[b.type] === filterMain.slice(4);
  return hasTag(b, filterMain);
}

/* ---------- detail panel ---------- */
const panel = document.getElementById('panel');
const live  = document.getElementById('live');
let lastFocus = null;

const bookOpen  = document.getElementById('bookOpen');
const leaf      = document.getElementById('leaf');
const leafFront = document.getElementById('leafFront');
const leafBack  = document.getElementById('leafBack');
const pgLeft    = document.getElementById('pgLeft');
const pgRight   = document.getElementById('pgRight');
const pTurn     = document.getElementById('pTurn');
const pBack     = document.getElementById('pBack');

/* ---------- the pages of one book ----------
   [cover] [what it is] [every page from the spread packs] [why it's on our shelf]
   The last page is the reason and the pairing, so turning through the book ends on
   us rather than opening on us. */
/* A book cover is portrait and the page is portrait, so it bleeds to the edge and is
   the page. A box lid is landscape: bleeding it into a portrait page crops the lid to
   its middle third and throws away both ends of the artwork. So anything landscape sits
   ON the page instead, centred with its own shadow — the same rule as the interior
   photographs. Keyed off `kind` today because every book here is portrait; the real
   test is orientation, so a landscape book cover would want this path too. */
/* Every image page is the same thing; whether it bleeds or sits on the paper is
   decided from its natural aspect at load, not from what kind of product it is. A
   scanned book page matches the page and fills it; a product photograph, even trimmed
   to its bounding box, usually doesn't, and cropping one to fit throws away the ends
   of it. Same idea as applyRatio on the shelf: measure the image, don't assume.

   A box's flat lid stays on the shelf, where face-on is right for something standing
   up; the reader opens on covPage, the product shot. */
function imgPage(src, alt){
  return '<div class="page-img"><img src="' + src + '" alt="' + (alt || '') + '"></div>';
}
function coverPage(b){
  const src = b.covPage || b.cov;
  if(src) return imgPage(src, b.t);
  return '<div class="page-inner pg-cover"><span class="jacket' + jacketClass(b) +
    '" style="--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><span></span><span class="j-t">' + b.t +
    '</span><span class="j-a">' + b.a + '</span></span></div>';
}
/* Two voices, and both earn their place. `d` is ours — short, why it's on this shelf.
   `blurb` is the publisher's own selling copy from the feed's description field, which
   someone was paid to write about this exact book. Ours reads as a standfirst, theirs
   as the body under it. */
function aboutPage(b){
  const blurb = b.blurb
    ? '<div class="pg-blurb"><span class="eyebrow">From the publisher</span><p>' +
      b.blurb + '</p></div>'
    : '';
  return '<div class="page-inner about-page">' +
    '<span class="pg-chip">' + b.type + (b.detail ? ' · ' + b.detail : '') + '</span>' +
    '<div class="pg-title">' + b.t + '</div>' +
    '<div class="pg-by">' + b.a + ' · ' + b.pub + '</div>' +
    '<p class="pg-stand">' + b.d + '</p>' + blurb + '</div>';
}
function insidePage(src){ return imgPage(src); }
function blankPage(b){
  return '<div class="page-inner"><div class="page-epigraph"><p>' + b.shelf_caption + '</p></div></div>';
}
/* The closing page is the paired toy, given a whole page rather than a box in the
   corner of an empty one. In Liquid the media area is the theme's own product card —
   {% render 'card-product', card_product: pairing %} — so the image, price and badges
   come from Shopify and stay in step with the product. Here it's a marked slot.

   The card is not itself a link. Tap-to-turn means a page-sized click target would
   send anyone flicking through straight to a product page; the small CTA is the only
   thing that navigates. */
const ADDON_EXTRA = 25;   /* % off the book when a toy goes in the same basket */

function whyPage(b){
  const reason = b.pairing_reason ? b.pairing_reason.charAt(0).toUpperCase() + b.pairing_reason.slice(1)
                     : 'It is here for one reason: we would keep it ourselves.';
  const card = b.pairing_name
    ? '<div class="prod-card">' +
        osbPairMediaHTML(b) +
        '<div class="pc-body">' +
          '<span class="pc-eyebrow">Made to go together</span>' +
          '<span class="pc-name">' + b.pairing_name + '</span>' +
          osbPairInfoHTML(b) +
          '<div class="pc-buy">' +
            '<button class="btn" data-both="' + b.pairing_name + '">Add both</button>' +
            '<button class="btn btn-quiet" data-only="1">Just the book · ' + b.price + '</button>' +
          '</div>' +
          '<p class="pg-offer">Buy the toy and the book together and take a further ' +
          ADDON_EXTRA + '% off the book, automatically added in cart.</p>' +
          '<a class="pc-cta" href="' + b.pairing_url + '">Engraving is free \u2014 add it on ' +
          osbWithArticle(b.pairing_name) + ' page &rsaquo;</a>' +
        '</div>' +
      '</div>'
    : '';
  return '<div class="page-inner why-page">' +
    '<div class="pg-kicker">Why it\u2019s on our shelf</div>' +
    '<div class="pg-why">' + reason + '</div>' + card + '</div>';
}
function buildPages(b){
  const p = [coverPage(b), aboutPage(b)];
  const inside = b.interior || [];
  inside.forEach(src => p.push(insidePage(src)));
  /* a book always opens onto something; a box doesn't have pages to open at all */
  if(!inside.length && !isBox(b)) p.push(blankPage(b));
  p.push(whyPage(b));
  return p;
}

/* ---------------- turning ----------------
   i is the index of the page on the leaf's front.
   Two-up: the leaf holds the right-hand page, so i is odd and a turn moves two.
   One-up: the leaf is the whole page, so a turn moves one. */
let PAGES = [], i = 0, turning = false, currentKey = null;
/* A page's shape, taken from the opening image. 0.757 only until one loads. */
let pageAR = 0.757;

/* Two pages side by side only for a portrait book. A landscape one is already wide;
   opening it as a spread would give a 2.9:1 letterbox 300px tall. */
const twoUp = () => window.innerWidth > 1000 && pageAR < 1 && !(currentKey && BOOKS[currentKey].one_up);

function applyShape(){
  bookOpen.style.setProperty('--ratio', (twoUp() ? pageAR * 2 : pageAR).toFixed(4));
  bookOpen.classList.toggle('one-up', !twoUp());
}
const step  = () => twoUp() ? 2 : 1;
const first = () => twoUp() ? 1 : 0;
const at = n => (n >= 0 && n < PAGES.length) ? PAGES[n] : '';

function dim(el){ el.querySelectorAll('a,button').forEach(x => x.tabIndex = -1); }

/* Fill the page when the image is close to the page's own shape; sit on it when it
   isn't. 12% either way, so a small mismatch still crops (nobody misses two percent
   of an edge) while a real one is left whole. */
function fitPage(img){
  const box = img.parentElement.getBoundingClientRect();
  if(!box.height || !img.naturalHeight) return;
  const off = (img.naturalWidth / img.naturalHeight) / (box.width / box.height);
  img.parentElement.classList.toggle('contain', off > 1.12 || off < 0.89);
}
function fitPages(){
  document.querySelectorAll('#bookOpen .page-img img').forEach(img=>{
    if(img.complete) fitPage(img); else img.addEventListener('load',()=>fitPage(img),{once:true});
  });
}

const zoneNext = document.getElementById('zoneNext');

function render(){
  leafFront.innerHTML = at(i);
  leafBack.innerHTML  = at(i + 1);
  pgLeft.innerHTML    = twoUp() ? at(i - 1) : '';
  pgRight.innerHTML   = at(i + 1);      /* one-up: the page under the one on top */
  fitPages();
  dim(leafBack);                        /* facing away — keep it out of the tab order */
  leaf.classList.add('no-anim');
  leaf.style.transform = 'rotateY(0deg)';
  void leaf.offsetWidth;
  leaf.classList.remove('no-anim');
  const noFwd = i + 1 >= PAGES.length, noBack = i - step() < first();
  pTurn.disabled = noFwd;
  pBack.disabled = noBack;
  zoneNext.hidden = noFwd;
  bookOpen.classList.toggle('at-end', noFwd);   /* nothing under it, so don't cut it */
  document.getElementById('rbCount').textContent =
    Math.min(i + 1, PAGES.length) + ' / ' + PAGES.length;
}

const settle = (next, done) => {
  const end = () => { leaf.removeEventListener('transitionend', end); i = next; render(); done && done(); };
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){ i = next; render(); turning = false; return; }
  leaf.addEventListener('transitionend', end);
};

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const DUR = 620;

/* Put the right content on the right surfaces for a turn in this direction, and
   return the index we'd land on. Null means there's nowhere to go. */
function prep(dir){
  const next = i + dir * step();
  if(dir > 0 && i + 1 >= PAGES.length) return null;
  if(dir < 0 && next < first()) return null;
  if(twoUp()){
    if(dir > 0){ leafBack.innerHTML = at(i + 1); pgRight.innerHTML = at(i + 2); }
    else { leafFront.innerHTML = at(next); leafBack.innerHTML = at(next + 1);
           pgLeft.innerHTML = at(next - 1); pgRight.innerHTML = at(i + 1); }
  } else {
    if(dir > 0) pgRight.innerHTML = at(i + 1);
    else { leafFront.innerHTML = at(next); pgRight.innerHTML = at(i); }
  }
  return next;
}

/* One animation per layout, played forwards or in reverse — a backward turn is
   just the forward one unwound. Because it's an animation rather than a transition,
   a negative delay on a paused animation seeks it, which is what lets a drag scrub
   the turn frame by frame instead of only triggering it. */
function setAnim(dir, p, paused){
  leaf.style.animationName = twoUp() ? 'osbFlip' : 'osbTuck';
  leaf.style.animationDuration = DUR + 'ms';
  leaf.style.animationTimingFunction = 'linear';
  leaf.style.animationFillMode = 'forwards';
  leaf.style.animationDirection = dir > 0 ? 'normal' : 'reverse';
  leaf.style.animationDelay = (-p * DUR) + 'ms';
  leaf.style.animationPlayState = paused ? 'paused' : 'running';
}
function clearAnim(){ leaf.style.animation = ''; leaf.style.animationPlayState = ''; }
function commit(next){
  clearAnim(); bookOpen.classList.remove('turning','lit');
  i = next; render(); turning = false;
  osbCountTurn(i, PAGES.length);
}

function turnLeaf(dir){
  if(turning) return;
  const next = prep(dir);
  if(next === null) return;
  turning = true;
  bookOpen.classList.add('turning');
  if(reduced()){ commit(next); return; }
  setAnim(dir, 0, false);
  leaf.addEventListener('animationend', function done(){
    leaf.removeEventListener('animationend', done); commit(next);
  });
}

/* ---------- drag ----------
   The page follows the finger; let go past a third of the way and it completes,
   short of that and it goes back. Snapping back is the same animation played the
   other way from wherever the finger left it. */
let drag = null;
function dragSpan(){ return bookOpen.getBoundingClientRect().width * (twoUp() ? .5 : .85); }

bookOpen.addEventListener('pointerdown', e=>{
  if(turning || e.target.closest('a,button')) return;
  drag = {x:e.clientX, y:e.clientY, live:false, p:0, dir:0, next:null, moved:false};
});
bookOpen.addEventListener('pointermove', e=>{
  if(!drag) return;
  const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
  if(!drag.live){
    if(Math.abs(dx) < 9 || Math.abs(dx) < Math.abs(dy)) return;
    drag.dir = dx < 0 ? 1 : -1;
    drag.next = prep(drag.dir);
    if(drag.next === null){ drag = null; return; }
    drag.live = true; drag.moved = true; turning = true;
    bookOpen.classList.add('turning');
  }
  drag.p = Math.max(0, Math.min(1, (drag.dir > 0 ? -dx : dx) / dragSpan()));
  setAnim(drag.dir, drag.p, true);
});
function endDrag(){
  if(!drag) return;
  const d = drag; drag = null;
  if(!d.live) return;
  const finish = () => {
    leaf.addEventListener('animationend', function done(){
      leaf.removeEventListener('animationend', done);
      if(d.p > .3) commit(d.next);
      else { clearAnim(); bookOpen.classList.remove('turning'); render(); turning = false; }
    });
  };
  if(d.p > .3){ setAnim(d.dir, d.p, false); }
  else { setAnim(-d.dir, 1 - d.p, false); }   /* unwind from where they let go */
  finish();
}
bookOpen.addEventListener('pointerup', endDrag);
bookOpen.addEventListener('pointercancel', endDrag);

/* ---------- tap the page ---------- */
bookOpen.addEventListener('click', e=>{
  if(e.target.closest('a,button')) return;
  if(turning) return;
  const pairMedia = e.target.closest('.pc-media[data-href]');
  if(pairMedia){ location.href = pairMedia.getAttribute('data-href'); return; }
  const r = bookOpen.getBoundingClientRect();
  const x = (e.clientX - r.left) / r.width;
  turnLeaf(x < (twoUp() ? .5 : .32) ? -1 : 1);
});

/* Other editions of the same title: same `grp`, different binding. Clicking one
   opens that edition's own reader, so the page count and the interior pages come
   with it rather than only the price changing. */
const readerAlts = document.getElementById('readerAlts');
const raList = document.getElementById('raList');
function renderAlts(key){
  const grp = BOOKS[key].edition_group;
  const sibs = grp ? Object.keys(BOOKS).filter(k => BOOKS[k].edition_group === grp && k !== key) : [];
  readerAlts.hidden = !sibs.length;
  raList.innerHTML = sibs.map(k => {
    const s = BOOKS[k];
    const img = s.cov ? '<img src="' + s.cov + '" alt="">' : '';
    return '<button class="ra-item" data-alt="' + k + '">' + img +
      '<span><span class="ra-bind">' + s.type + '</span>' +
      '<span class="ra-price' + (s.rrp ? '' : ' no-rrp') + '">' +
      (s.rrp ? '<s>' + s.rrp + '</s>' : '') + '<b>' + s.price + '</b></span></span></button>';
  }).join('');
  raList.querySelectorAll('[data-alt]').forEach(el =>
    el.addEventListener('click', () => openBook(el.dataset.alt, false, 'edition')));
}

/* ---------- open and close ---------- */
function openBookCore(key){ osbReaderReady(function(){ osbPrewarm(key); osbOpenBookNow(key); }); }
function osbOpenBookNow(key){
  const b = BOOKS[key]; if(!b) return;
  /* shape the reader before anything is measured in it.
     NB: not `first` — that's the function giving the starting page index. */
  const opening = b.covPage || b.cov;
  pageAR = 0.757;
  if(opening){
    const probe = new Image();
    probe.onload = () => {
      pageAR = probe.naturalWidth / probe.naturalHeight;
      applyShape(); render();
    };
    probe.src = opening;
    if(probe.complete && probe.naturalWidth){ pageAR = probe.naturalWidth / probe.naturalHeight; }
  }
  applyShape();
  /* switching edition shouldn't overwrite where we came from */
  if(!panel.classList.contains('open')) lastFocus = document.activeElement;
  currentKey = key;
  PAGES = buildPages(b);
  i = first();
  document.getElementById('rbTitle').textContent = b.t;
  document.getElementById('rbBind').textContent = b.type;
  const rbPriceEl = document.getElementById('rbPrice');
  rbPriceEl.className = 'rb-price' + (b.rrp ? '' : ' no-rrp');
  rbPriceEl.innerHTML = (b.rrp ? '<s>' + b.rrp + '</s> ' : '') + '<b>' + b.price + '</b>';
  renderAlts(key);
  render();
  const img = leafFront.querySelector('.jacket img.cov-img') || pgLeft.querySelector('.jacket img.cov-img');
  if(img){ if(img.complete) applyRatio(img); else img.addEventListener('load',()=>applyRatio(img)); }
  panel.classList.add('open');
  document.body.style.overflow = 'hidden';
  panel.querySelector('.closex').focus();
}
function closeBookCore(){
  panel.classList.remove('open');
  document.body.style.overflow = '';
  if(lastFocus) lastFocus.focus();
}
pTurn.addEventListener('click',()=>turnLeaf(1));
pBack.addEventListener('click',()=>turnLeaf(-1));
/* the corner lifts on hover or keyboard focus — the cut and the flap grow together */
const lift = on => bookOpen.classList.toggle('lit', on);
zoneNext.addEventListener('pointerenter',()=>lift(true));
zoneNext.addEventListener('pointerleave',()=>lift(false));
pTurn.addEventListener('focus',()=>lift(true));
pTurn.addEventListener('blur', ()=>lift(false));
document.getElementById('rbAdd').addEventListener('click',e=>{
  if(currentKey) osbCartAdd(BOOKS[currentKey], false, e.currentTarget);
});

/* Both buttons are ordinary cart adds — one line item or two. The discount is a
   native Shopify Buy X Get Y (any product on the toy list, one book from the book
   list), so it applies in the cart on its own. Nothing here calculates a price, and
   a customer who already has a toy in the basket gets the same thing from the plain
   button. In Liquid this is /cart/add.js with items[].

   Engraving is a line item property rather than a variant, so adding with no
   properties adds the plain toy and no choice has to be made here. That is the point:
   one decision, not three. The cost is that someone who would have engraved never gets
   asked, and properties can't be edited once a line is in the cart — hence the link
   below the buttons, which exists to carry that rather than to be a generic "view
   product". Note also that the same toy added later WITH engraving becomes a second
   line item, not a quantity of the first. */
bookOpen.addEventListener('click', e=>{
  const both = e.target.closest('[data-both]');
  const only = e.target.closest('[data-only]');
  if(!both && !only) return;
  e.stopPropagation();                       /* don't also turn the page */
  const b = BOOKS[currentKey];
  osbCartAdd(b, !!both, both || only);
});
/* the page count changes when the layout does, so re-seat the index */
window.addEventListener('resize', ()=>{
  if(!panel.classList.contains('open')) return;
  applyShape();
  if(twoUp() && i % 2 === 0) i = Math.max(first(), i - 1);
  if(!twoUp() && i < 0) i = 0;
  render();
});

/* ---------- close, keys, focus ---------- */
document.querySelectorAll('[data-close]').forEach(el=>el.addEventListener('click',()=>closeBook()));
document.addEventListener('keydown',e=>{
  if(!panel.classList.contains('open')) return;
  if(e.key === 'Escape'){ closeBook(); return; }
  if(e.key === 'ArrowRight'){ e.preventDefault(); turnLeaf(1); return; }
  if(e.key === 'ArrowLeft'){ e.preventDefault(); turnLeaf(-1); return; }
  if(e.key !== 'Tab') return;
  /* keep focus inside the reader while it is open */
  const f = [...panel.querySelectorAll('button,a[href],[tabindex]:not([tabindex="-1"])')]
              .filter(el => el.offsetParent !== null && !el.disabled);
  if(!f.length) return;
  /* firstEl/lastEl, not first/last — `first` is the function giving the opening page */
  const firstEl = f[0], lastEl = f[f.length - 1];
  if(e.shiftKey && document.activeElement === firstEl){ e.preventDefault(); lastEl.focus(); }
  else if(!e.shiftKey && document.activeElement === lastEl){ e.preventDefault(); firstEl.focus(); }
});

/* ---------- shelves ---------- */
function perRow(){ return window.innerWidth < 700 ? 2 : 3; }   /* matches the CSS breakpoint */
const SCALE = {2:.175, 3:.12};   /* 1mm as a fraction of the row, before fitting */

/* A boxed game has no spine to fold and no board to roll, so it gets neither the
   hinge nor the bound-board corner — just a lid with a rim. Softer hinge for anything
   perfect-bound or stapled; the full roll only for a sewn hardback. */
const jacketClass = b => (isBox(b) ? ' is-box'
  : (/paperback|sticker|press-out/i.test(b.type) ? ' soft-hinge' : ''))
  + (/board book/i.test(b.type) ? ' board-corners' : '');

function bookHTML(k){
  const b = BOOKS[k];
  /* no spread, no swap — same as a collection-page product with one photo. A paper
     stand-in reading "a page from inside" is a placeholder impersonating content. */
  const spread = b.hover
    ? '<span class="spread' + (b.hover_bleed ? ' bleed' : '') + '"><img src="' + b.hover + '" alt=""></span>' : '';
  const face = b.cov
    ? '<span class="jacket has-cover' + jacketClass(b) + '" style="--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><img class="cov-img" src="' + b.cov + '" alt="' + b.t + ' cover">' + spread + '</span>'
    : '<span class="jacket' + jacketClass(b) + '" style="--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><span></span><span class="j-t">' + b.t + '</span><span class="j-a">' + b.a + '</span>' + spread + '</span>';
  /* spines are second copies of the same title: decorative, never in the tab order */
  const spines = b.spines.map(s =>
    '<span class="spine' + (s.lean ? ' lean' : '') + '" aria-hidden="true" style="--h:' + b.h + ';--t:' + s.t + ';--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><span>' + b.t + '</span></span>').join('');
  /* .book is a <button>, so the quick-add can't nest inside it — .book-face is the
     positioning context that holds both and aligns to the cover, not to the spines */
  return '<div class="book-wrap">' +
      '<span class="book-face">' +
        '<button class="book" data-book="' + k + '" style="--h:' + b.h + '">' + face + '</button>' +
        '<button class="quick-add" data-add="' + k + '" aria-label="Add ' + b.t + ' to your basket"></button>' +
      '</span>' +
      spines +
      '<span class="tag' + (b.rrp ? '' : ' no-rrp') + '">' +
        (b.rrp ? '<span class="t-rrp">' + b.rrp + '</span>' : '') +
        '<span class="t-price">' + b.price + '</span></span>' +
    '</div>';
}

/* The shelf line is a title and a description. The pairing used to live here as
   "Sits beside the …" — a sentence pretending to be a label, repeated on twelve of
   sixteen cards, asserting a connection while hiding the reason for it. It's in the
   open book now, where there's room to say why. */
function capHTML(k){
  const b = BOOKS[k];
  const bind = b.type;
  return '<div class="cap-cell" data-cap="' + k + '">' +
    '<span class="b-cap"><b>' + b.t + '</b>' +
    '<span class="b-bind">' + bind + '</span>' + b.shelf_caption + '</span></div>';
}

/* the cover image is the source of truth for shape; mm gives height only */
/* Shape comes from the cover image itself, never from the feed's dimensions — those
   arrive width-first for some products and height-first for others. Only ever called
   with a .cov-img. */
function applyRatio(img){
  const wrap = img.closest('.jacket');
  if(img.naturalWidth && wrap) wrap.style.setProperty('aspect-ratio', img.naturalWidth + '/' + img.naturalHeight);
}

/* scale each shelf down if its row would overflow, so adding a title can't break the page */
function fitShelf(shelf){
  const base = SCALE[perRow()];
  shelf.style.setProperty('--mm', base);
  const row = shelf.querySelector('.shelf-books');
  const kids = [...row.children];
  if(!kids.length) return;
  const cs = getComputedStyle(row);
  const chrome = parseFloat(cs.gap) * (kids.length - 1)
               + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
  const books = kids.reduce((a,el)=>a + el.getBoundingClientRect().width, 0);
  const room  = row.clientWidth * 0.94 - chrome;
  if(books > room) shelf.style.setProperty('--mm', base * (room / books));
  /* re-measure after any rescale, then give each caption its book's exact width */
  const cells = [...shelf.querySelectorAll('.cap-cell')];
  kids.forEach((el,i)=>{ if(cells[i]) cells[i].style.width = el.getBoundingClientRect().width + 'px'; });
}

/* Editions of one title must never be split across two shelves — a hardback on the
   end of one row and its board book at the start of the next reads as two unrelated
   books. So rows are packed by UNIT rather than sliced by index: a group of editions
   is one indivisible unit, a standalone book is a unit of one, and each row takes the
   first unit that still fits. In practice that pulls a standalone book forward to fill
   the gap a pair can't fit into, which is exactly the swap you'd make by hand. A group
   larger than a row is the one case that has to break; it takes whole rows first. */
function packRows(keys, n){
  const units = [];
  for(let i = 0; i < keys.length; ){
    const g = BOOKS[keys[i]].edition_group;
    if(g){ const run = []; while(i < keys.length && BOOKS[keys[i]].edition_group === g) run.push(keys[i++]); units.push(run); }
    else units.push([keys[i++]]);
  }
  const rows = [];
  let row = [], pending = units;
  while(pending.length){
    const space = n - row.length;
    const idx = pending.findIndex(u => u.length <= space);
    if(idx === -1){
      if(row.length){ rows.push(row); row = []; continue; }
      rows.push(pending.shift().slice(0, n));    /* group too big for any row */
      continue;
    }
    row.push(...pending.splice(idx, 1)[0]);
    if(row.length === n){ rows.push(row); row = []; }
  }
  if(row.length) rows.push(row);
  return rows;
}

function drawRacks(){
  const n = perRow();
  document.querySelectorAll('[data-rack]').forEach(rack=>{
    const keys = KEYS.filter(k => hasTag(BOOKS[k], 'shelf:' + rack.dataset.rack) && inFilter(k));
    let out = '';
    packRows(keys, n).forEach(row=>{
      out += '<div class="shelf">'
           + '<div class="shelf-books" style="--maxh:' + Math.max.apply(null, row.map(k => +BOOKS[k].h || 260)) + '">' + row.map(bookHTML).join('') + '</div>'
           + '<div class="shelf-plank"><div class="plank-back"></div><div class="plank-front"></div></div>'
           + '<div class="shelf-caps">' + row.map(capHTML).join('') + '</div>'
           + '</div>';
    });
    rack.innerHTML = out || '<p class="empty">Nothing on this shelf for that age yet.</p>';
    rack.closest('.case').hidden = !keys.length;
  });

  document.querySelectorAll('.shelf .book').forEach(el=>{
    el.addEventListener('click',()=>openBook(el.dataset.book, false, 'shelf'));
  });
  document.querySelectorAll('.shelf [data-add]').forEach(t=>{
    t.addEventListener('click',e=>{
      e.stopPropagation();
      osbCartAdd(BOOKS[t.dataset.add], false, t);
    });
  });
  /* .cov-img only. The hover spread is also an <img> inside .jacket, and reading its
     ratio here set the jacket's shape from the wrong picture — which cropped every
     landscape box to portrait. Never select these by position or descent. */
  document.querySelectorAll('.shelf .jacket img.cov-img').forEach(img=>{
    if(img.complete) applyRatio(img); else img.addEventListener('load',()=>applyRatio(img));
  });
  /* a duplicate copy's spine is the left edge of its own cover, at cover scale */
  document.querySelectorAll('.shelf .book-wrap').forEach(w=>{
    const img = w.querySelector('.book img.cov-img'); if(!img) return;
    w.querySelectorAll('.spine').forEach(sp=>{
      sp.style.backgroundImage = 'url("' + img.getAttribute('src') + '")';
      sp.classList.add('has-cover');
    });
  });
  document.querySelectorAll('.shelf').forEach(fitShelf);
}
drawRacks();

/* Container width, not window width — the shelves are sized in container units.
   Guarded two ways: only react to a WIDTH change (our own resizing alters height
   only), and do the work in the next frame, so the observer never re-enters
   itself mid-delivery. */
const rackEl = document.querySelector('.cases .wrap');
let lastN = perRow(), lastW = rackEl.getBoundingClientRect().width, queued = false;
new ResizeObserver(entries=>{
  const w = entries[0].contentRect.width;
  if(Math.abs(w - lastW) < 1 || queued) return;
  lastW = w; queued = true;
  requestAnimationFrame(()=>{
    queued = false;
    if(perRow() !== lastN){ lastN = perRow(); drawRacks(); }
    else document.querySelectorAll('.shelf').forEach(fitShelf);
  });
}).observe(rackEl);

/* ---------- age filter ---------- */
function bindChips(sel, set){
  document.querySelectorAll(sel).forEach(chip=>{
    chip.addEventListener('click',()=>{
      set(chip.dataset.filter);
      osbTrack('book_filter:' + osbFilterLabel(chip.dataset.filter));
      document.querySelectorAll(sel).forEach(c=>c.setAttribute('aria-pressed', c===chip ? 'true':'false'));
      drawRacks();
      live.textContent = KEYS.filter(inFilter).length + ' on the shelf.';
    });
  });
}
bindChips('.chips-main .chip', v => filterMain = v);
bindChips('.chips-age  .chip', v => filterAge  = v);
document.querySelectorAll('details.age-filter').forEach(d => d.addEventListener('toggle', () => { if (d.open) osbTrack('book_filter:age-open'); }));

/* ---------- hero carousel ---------- */
if (document.getElementById('carStage')) {

const stage = document.getElementById('carStage');
const dots  = document.getElementById('carDots');
const count = document.getElementById('carCount');
/* The carousel is a chosen set, not the whole shelf — everything carries
   carousel:featured today, but the tag is the switch for picking a handful to push
   in a campaign without touching the shelf itself. */
const FEATURED = KEYS.filter(k => hasTag(BOOKS[k], 'carousel:featured'));
const N = FEATURED.length;
let cur = 0;

stage.innerHTML = FEATURED.map(k=>{
  const b = BOOKS[k];
  const face = b.cov
    ? '<span class="jacket has-cover' + jacketClass(b) + '" style="--h:' + b.h + ';--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><img class="cov-img" src="' + b.cov + '" alt=""></span>'
    : '<span class="jacket' + jacketClass(b) + '" style="--h:' + b.h + ';--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><span></span><span class="j-t">' + b.t + '</span><span class="j-a">' + b.a + '</span></span>';
  return '<div class="car-slot" data-key="' + k + '"><button class="car-card" tabindex="-1">' + face +
    '<span class="car-meta"><span class="car-t">' + b.t + '</span><span class="car-p">' + b.price + '</span></span>' +
    '</button></div>';
}).join('');
stage.querySelectorAll('.jacket img.cov-img').forEach(img=>{
  if(img.complete) applyRatio(img); else img.addEventListener('load',()=>applyRatio(img));
});

const slots = [...stage.querySelectorAll('.car-slot')];
dots.innerHTML = FEATURED.map(()=>'<i></i>').join('');
const pips = [...dots.querySelectorAll('i')];

function offset(i){ let d = (i - cur + N) % N; if(d > N/2) d -= N; return d; }
function place(){
  slots.forEach((s,i)=>{
    const d = offset(i);
    s.className = 'car-slot ' + (d===0 ? 'is-centre' : d===-1 ? 'is-left' : d===1 ? 'is-right'
                                : d<0 ? 'is-far-left' : 'is-far-right');
    const btn = s.querySelector('.car-card');
    btn.tabIndex = d === 0 ? 0 : -1;
    btn.setAttribute('aria-hidden', Math.abs(d) > 1 ? 'true' : 'false');
  });
  pips.forEach((p,i)=>{
    const d = Math.abs(offset(i));
    p.className = d===0 ? 'on' : d===1 ? 'near' : d===2 ? 'edge' : '';
  });
  count.textContent = (cur+1) + '/' + N;
}
function go(dir){ cur = (cur + dir + N) % N; place(); osbTrack('book_carousel:' + (dir > 0 ? 'next' : 'prev')); }

slots.forEach((s,i)=>{
  s.querySelector('.car-card').addEventListener('click',()=>{
    const d = offset(i);
    if(d === 0) openBook(s.dataset.key, false, 'carousel');   /* centre card opens the book */
    else go(d > 0 ? 1 : -1);               /* a peeking card turns the shelf */
  });
});
document.getElementById('carPrev').addEventListener('click',()=>go(-1));
document.getElementById('carNext').addEventListener('click',()=>go(1));

/* touch: drag the stack sideways, one book per swipe */
let dragX = null, dragY = null, dragging = false;
stage.addEventListener('pointerdown', e=>{ dragX = e.clientX; dragY = e.clientY; dragging = true; });
stage.addEventListener('pointerup', e=>{
  if(!dragging) return;
  dragging = false;
  const dx = e.clientX - dragX, dy = e.clientY - dragY;
  if(Math.abs(dx) > 34 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
});
stage.addEventListener('pointercancel', ()=>{ dragging = false; });
stage.addEventListener('keydown', e=>{
  if(e.key === 'ArrowLeft'){ e.preventDefault(); go(-1); }
  if(e.key === 'ArrowRight'){ e.preventDefault(); go(1); }
});
place();
}

/* ---------- URL sync — ?book=<handle> deep-links straight into a reader ----------
   Opening a book from the shelf pushes ?book= (one history step per book
   opened). Closing takes that step back off rather than pushing a new bare
   entry: history.back() when this page pushed the book's step, or a
   replaceState to the bare URL when it did not (a ?book= landing). Switching
   edition replaces the current step, because it is not a new place. So Back
   with a book open closes it, and Back with the shelf showing leaves the page.
   Whether the current step was pushed here rides in history.state.osbPushed,
   which the browser restores with the entry on Back, Forward and reload.
   Landing with ?book= opens that title. */
const KEY_BY_HANDLE = {};
KEYS.forEach(k => { if (BOOKS[k].handle) KEY_BY_HANDLE[BOOKS[k].handle] = k; });
function osbPushedHere(){ return !!(history.state && history.state.osbPushed); }
function syncUrl(key, replace){
  const u = new URL(location.href);
  if (key) u.searchParams.set('book', BOOKS[key].handle);
  else u.searchParams.delete('book');
  if (replace) history.replaceState({ book: key || null, osbPushed: !!key && osbPushedHere() }, '', u);
  else history.pushState({ book: key || null, osbPushed: true }, '', u);
}
/* ⛔ THE REPORT COMES AFTER THE URL SYNC, DELIBERATELY. No event name may carry
   a book handle (GA4's distinct-name cap — see shelf-runtime.js), so the title
   rides in stape_events.pageUrl instead, which the beacon reads from
   location.href as it fires. syncUrl has written ?book= by then; move the call
   above it and every open reports as the bare shelf URL.
   The other three paths need no such care: popstate and the deep-link landing
   both run with the query string ALREADY correct, and closing reports nothing
   book-specific. */
function openBook(key, silent, source){ openBookCore(key); if (!silent) syncUrl(key, source === 'edition'); osbTrackOpen(source); }
/* book_close is reported with the bare shelf URL on every path, as Back has
   always reported it. history.back() is asynchronous, so on that path the
   report waits for the popstate it causes (the URL is bare by then); the panel
   is already shut, so the popstate's own close branch does nothing and the
   close is counted once. If back() leaves the document instead (a reloaded
   ?book= step whose shelf entry belongs to the previous load), pagehide sends
   the report on the way out. */
let osbClosePending = false;
function osbFlushClose(){ if (osbClosePending) { osbClosePending = false; osbTrack('book_close'); } }
function closeBook(silent){
  const wasOpen = panel.classList.contains('open');
  closeBookCore();
  if (!silent && wasOpen && osbPushedHere()) { osbClosePending = true; history.back(); return; }
  if (!silent && wasOpen) syncUrl(null, true);
  osbTrack('book_close');
}
window.addEventListener('pagehide', osbFlushClose);
window.addEventListener('popstate', () => {
  osbFlushClose();
  const h = new URLSearchParams(location.search).get('book');
  const k = h ? KEY_BY_HANDLE[h] : null;
  if (k) { openBookCore(k); osbTrackOpen('history'); }
  else if (panel.classList.contains('open')) { closeBookCore(); osbTrack('book_close'); }
});
(function(){
  const h = new URLSearchParams(location.search).get('book');
  const k = h ? KEY_BY_HANDLE[h] : null;
  /* ?book= is how EVERY book product page now arrives — book PDPs redirect
     here (scripts/books-build/book-pdp-redirect.mts) — so this is the paid and
     organic landing path, not a niche one. It fires on page LOAD, which is
     precisely the case window.__OS_TRACK__ does not exist for yet; osbTrack
     queues it. */
  if (k) { openBookCore(k); history.replaceState({ book: k, osbPushed: osbPushedHere() }, '', location.href); osbTrackOpen('deeplink'); }
})();

/* Ask for the reader payload before anyone needs it — on idle, and on the first
   pointer or focus to land on the shelf. Last, so the shelf is drawn and the
   listeners have something to attach to. */
osbScheduleReader();

